import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/storybook-components';
import success from '@learningblocks/exp-constants/lib/Images/success.svg';
import failed from '@learningblocks/exp-constants/lib/Images/AlertLargeFail.svg';
import style from './style.module.scss';

export function HintBlock(props) {
  const renderHintIcon = () => {
    if (props.balance) {
      return success;
    } else {
      return failed;
    }
  };
  return (
    <div className={style.heatBlockHint}>
      <h3>HINT!</h3>
      <p>
        Make sure the current temperature has reached the set temperature before
        adding your samples.
      </p>
      <div className={style.heatBlockHint_details}>
        <p>
          Current temperature equals set temperature: 
          {props.balance ? ' Yes' : ' No'}
        </p>
        <Image
          src={renderHintIcon()}
          alt='indecation-icon'
          className={style.heatBlockHint_details_img}
        />
      </div>
    </div>
  );
}

HintBlock.propTypes = {
  /**
   * It denotes the current temperature and the setTemperature is equal or not
   */
  balance: PropTypes.bool,
};
